/**
 * Gate for the live AR mirror. The shipped mirror only needs camera +
 * MediaPipe tracking + a Canvas2D overlay — the exact same stack the iOS
 * photo-capture flow already runs in WKWebView (Capture.svelte's scan loop).
 * It is deliberately NOT tied to canUseWebGL2Renderer(): that gate protects
 * the OffscreenCanvas/WebGL2 photo-render pipeline, which the mirror never
 * touches. iPhones get the mirror too; the in-mirror "use a photo" fallback
 * stays available for camera-less or denied devices.
 */
export function canUseLiveMirror(): boolean {
  return Boolean(navigator.mediaDevices?.getUserMedia);
}
